import { render } from "./BookPaymentFailed.vue?vue&type=template&id=3f09101b"
const script = {}

import exportComponent from "/var/www/probusandcar.com/mobile_probus_app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__